/** @graphql cc **/
import gql from 'graphql-tag';

export const AudienceSegmentationContextProviderQuery = gql`
	query AudienceSegmentationContextProviderQuery($accountId: ID) {
		user: confluence_atlassianUser(id: $accountId) {
			id
			confluence {
				groupsWithId {
					id
				}
			}
		}
	}
`;
